module.exports = __webpack_public_path__ + "static/media/menu9.2d5db97a.png";